import { Box, styled } from "@mui/material";

export const SearchWithAutocompleteWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "2rem",
  borderBottom: `1px solid ${theme.palette.border.main}`,
  marginBottom: "25px",
  position: "sticky",
  top: "64px",
  background: "white",
  zIndex: "5",
  gap: "1rem",
  flexWrap: "wrap",
}));

export const SearchBox = styled(Box)(({ theme }) => ({
  minWidth: "300px",
  ".MuiTextField-root": {
    width: "100%",
  },
}));
